<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row mb-4">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Extrato de Movimentações</h1>
                        <p class="welcome-message">Gerenciamento de entradas e saídas</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 header-actions">
                <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu"
                    [disabled]="_isLoadingAction">
                    @if (temSelecionados) {
                    <span>Ações ({{selection.selected.length}})</span>
                    } @else if (_isLoadingAction) {
                    <span>Carregando</span>
                    } @else {
                    <span>Ações</span>
                    }
                    @if (_isLoadingAction) {
                    <mat-spinner [diameter]="18" class="mat-spinner-btn"></mat-spinner>
                    } @else {
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                    }
                </button>

                <mat-menu #opcoesMenu="matMenu">
                    @if (temSelecionados) {
                    <button mat-menu-item (click)="abrirModalTags()">
                        <mat-icon class="material-symbols-outlined">label</mat-icon>
                        <span>Alterar tags</span>
                    </button>
                    <button mat-menu-item (click)="abrirModalAlterarCategoria()">
                        <mat-icon class="material-symbols-outlined">category</mat-icon>
                        <span>Alterar categoria</span>
                    </button>
                    <span class="ext-menu-item-tooltip" [matTooltip]="tooltipSelecaoComDocumento"
                        [matTooltipDisabled]="!temSelecionadoDaVenda">
                        <button mat-menu-item (click)="abrirModalAlterarConta()" [disabled]="temSelecionadoDaVenda">
                            <mat-icon class="material-symbols-outlined">account_balance</mat-icon>
                            <span>Alterar conta financeira</span>
                        </button>
                    </span>
                    <button mat-menu-item (click)="imprimirRecibos()">
                        <mat-icon class="material-symbols-outlined">receipt</mat-icon>
                        <span>Imprimir recibos</span>
                    </button>
                    <mat-divider></mat-divider>
                    <span class="ext-menu-item-tooltip" [matTooltip]="tooltipSelecaoComDocumento"
                        [matTooltipDisabled]="!temSelecionadoDaVenda">
                        <button mat-menu-item (click)="excluirSelecionados()" [disabled]="temSelecionadoDaVenda">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                            <span>Excluir lançamentos</span>
                        </button>
                    </span>
                    } @else {
                    <button mat-menu-item routerLink="/financas/transferencias/cadastrar">
                        <mat-icon class="material-symbols-outlined">sync_alt</mat-icon>
                        <span>Transferir entre contas</span>
                    </button>
                    <button mat-menu-item (click)="imprimirRelatorio()">
                        <mat-icon class="material-symbols-outlined">print</mat-icon>
                        <span>Imprimir relatório</span>
                    </button>
                    <button mat-menu-item (click)="exportarLancamentos()" [disabled]="_isLoadingAction">
                        <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
                        <span>Exportar lançamentos para planilha</span>
                    </button>
                    <button mat-menu-item (click)="abrirModalImportarLancamentos()">
                        <mat-icon class="material-symbols-outlined">file_download</mat-icon>
                        <span>Importar lançamentos de uma planilha</span>
                    </button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="abrirModalFechamento()">
                        <mat-icon class="material-symbols-outlined">lock_clock</mat-icon>
                        <span>Gerenciar fechamento financeiro</span>
                    </button>
                    }
                </mat-menu>

                @if (!temSelecionados) {
                <button mat-stroked-button class="btn-secondary" routerLink="/financas/transferencias/cadastrar">
                    <mat-icon class="material-symbols-outlined">sync_alt</mat-icon>
                    Nova transferência
                </button>
                }

                <button type="button" mat-flat-button class="btn-primary" routerLink="/financas/lancamentos/cadastrar">
                    <mat-icon>add</mat-icon>
                    Novo Lançamento
                </button>
            </div>
        </div>

        @if (_dataFechamento) {
        <div class="alert-fechamento mb-3">
            <mat-icon class="alert-fechamento-icon">warning_amber</mat-icon>
            <span>Os lançamentos no caixa até a data <strong>{{_dataFechamento | date:'dd/MM/yyyy'}}</strong> estão
                bloqueados, pois foi realizado o fechamento do período financeiro.</span>
            <button mat-button class="btn-fechamento-action" (click)="abrirModalFechamento()">Alterar</button>
        </div>
        }

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area g-3">
                <div class="col-xl-3 col-lg-6 col-12">
                    <mat-form-field appearance="outline" class="filter-pesquisa">
                        <mat-label>Pesquisar</mat-label>
                        <input matInput formControlName="pesquisa" placeholder="Buscar por histórico...">
                        <button mat-icon-button matSuffix type="submit">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="col-xl-2 col-lg-3 col-md-6 col-12">
                    <mat-form-field appearance="outline" class="filter-select">
                        <mat-label>Conta</mat-label>
                        <mat-select formControlName="conta" (selectionChange)="clickPesquisar()">
                            <mat-option value="todas">Todas</mat-option>
                            @for (conta of _contas; track conta.id) {
                            <mat-option [value]="conta.id">{{conta.nome}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-xl-7 col-lg-12 col-12">
                    <div class="filter-actions">
                        <button #periodoMenuTrigger="matMenuTrigger" mat-stroked-button type="button"
                            class="btn-periodo" [matMenuTriggerFor]="periodoMenu"
                            (menuOpened)="prepararPeriodoIntervalo()"
                            [class.btn-periodo--ativo]="periodoSelecionado !== PeriodoExtratoEnum.Ultimos30Dias && periodoSelecionado !== undefined">
                            {{ periodoLabel }}
                            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                        </button>
                        <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
                            <div class="periodo-menu-content">
                                <div>
                                    <button type="button" class="periodo-menu-item"
                                        (click)="selecionarPeriodo(PeriodoExtratoEnum.Hoje); aplicarPeriodo()"
                                        [class.periodo-item-selecionado]="periodoSelecionado === PeriodoExtratoEnum.Hoje">
                                        <span>hoje</span>
                                        @if (periodoSelecionado === PeriodoExtratoEnum.Hoje) {
                                        <mat-icon>check</mat-icon>
                                        }
                                    </button>
                                    <button type="button" class="periodo-menu-item"
                                        (click)="selecionarPeriodo(PeriodoExtratoEnum.DaSemana); aplicarPeriodo()"
                                        [class.periodo-item-selecionado]="periodoSelecionado === PeriodoExtratoEnum.DaSemana">
                                        <span>desta semana</span>
                                        @if (periodoSelecionado === PeriodoExtratoEnum.DaSemana) {
                                        <mat-icon>check</mat-icon>
                                        }
                                    </button>
                                    <button type="button" class="periodo-menu-item"
                                        (click)="selecionarPeriodo(PeriodoExtratoEnum.DoMes); aplicarPeriodo()"
                                        [class.periodo-item-selecionado]="periodoSelecionado === PeriodoExtratoEnum.DoMes">
                                        <span>do mês</span>
                                        @if (periodoSelecionado === PeriodoExtratoEnum.DoMes) {
                                        <mat-icon>check</mat-icon>
                                        }
                                    </button>
                                    <button type="button" class="periodo-menu-item"
                                        (click)="selecionarPeriodo(PeriodoExtratoEnum.Ultimos30Dias); aplicarPeriodo()"
                                        [class.periodo-item-selecionado]="periodoSelecionado === PeriodoExtratoEnum.Ultimos30Dias">
                                        <span>últimos 30 dias</span>
                                        @if (periodoSelecionado === PeriodoExtratoEnum.Ultimos30Dias) {
                                        <mat-icon>check</mat-icon>
                                        }
                                    </button>
                                    <button type="button" class="periodo-menu-item"
                                        (click)="selecionarPeriodo(PeriodoExtratoEnum.DoIntervalo); $event.stopPropagation()"
                                        [class.periodo-item-selecionado]="periodoSelecionado === PeriodoExtratoEnum.DoIntervalo">
                                        <span>do intervalo</span>
                                        @if (periodoSelecionado === PeriodoExtratoEnum.DoIntervalo) {
                                        <mat-icon>check</mat-icon>
                                        }
                                    </button>

                                    @if (periodoSelecionado === PeriodoExtratoEnum.DoIntervalo) {
                                    <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                                        <mat-form-field appearance="outline">
                                            <mat-label>De</mat-label>
                                            <input matInput [matDatepicker]="pickerInicio" placeholder="DD/MM/AAAA"
                                                formControlName="dataInicioCustom"
                                                (input)="onDateInput($event, 'dataInicioCustom')">
                                            <mat-datepicker-toggle matSuffix
                                                [for]="pickerInicio"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerInicio></mat-datepicker>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline">
                                            <mat-label>Até</mat-label>
                                            <input matInput [matDatepicker]="pickerFim" placeholder="DD/MM/AAAA"
                                                formControlName="dataFimCustom"
                                                (input)="onDateInput($event, 'dataFimCustom')">
                                            <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerFim></mat-datepicker>
                                        </mat-form-field>

                                        <div class="periodo-intervalo-actions">
                                            <button type="button" mat-stroked-button class="btn-secondary"
                                                (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">
                                                Cancelar
                                            </button>
                                            <button type="button" mat-flat-button class="btn-primary"
                                                (click)="aplicarPeriodo(periodoMenuTrigger)">
                                                Aplicar
                                            </button>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </mat-menu>

                        <button type="button" mat-stroked-button class="btn-filter"
                            [class.btn-filter-active]="qtdFiltrosAvancados > 0" [matBadge]="qtdFiltrosAvancados"
                            [matBadgeHidden]="qtdFiltrosAvancados === 0" matBadgeColor="primary"
                            (click)="abrirModalFiltros()">
                            <mat-icon class="material-symbols-outlined">filter_list</mat-icon>
                            Filtrar
                        </button>

                        <button type="button" mat-stroked-button class="btn-filter" (click)="limparFiltros()">
                            <mat-icon>cleaning_services</mat-icon>
                            Limpar Filtros
                        </button>

                        <button type="button" mat-stroked-button class="btn-filter"
                            (click)="abrirModalConfigurarColunas()">
                            <mat-icon>view_column</mat-icon>
                            Configurar Colunas
                        </button>
                    </div>
                </div>
            </div>
        </form>

        @if (_dataSource.data.length > 0) {
        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="data">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Data</th>
                <td mat-cell *matCellDef="let row">{{row.data | date:'dd/MM/yyyy'}}</td>
            </ng-container>

            <ng-container matColumnDef="historico">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Histórico</th>
                <td mat-cell *matCellDef="let row">
                    <div class="historico-cell">
                        <span class="historico-text" [matTooltip]="row.historico">{{row.historico | truncate:50}}</span>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="cliente">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Cliente</th>
                <td mat-cell *matCellDef="let row">{{row.cliente}}</td>
            </ng-container>

            <ng-container matColumnDef="categoria">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Categoria</th>
                <td mat-cell *matCellDef="let row">{{row.categoria}}</td>
            </ng-container>

            <ng-container matColumnDef="valor">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Valor (R$)</th>
                <td mat-cell *matCellDef="let row" class="text-end">
                    <span [ngClass]="{'valor-entrada': row.tipo === 'entrada', 'valor-saida': row.tipo === 'saida'}">
                        {{formatarValor(row.valor, row.idNaturezaMovimentacao)}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="tags">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Tags</th>
                <td mat-cell *matCellDef="let row">
                    <div class="tags-container">
                        @for (tag of row.tags; track tag.id) {
                        <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
                        }
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="origem">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Origem</th>
                <td mat-cell *matCellDef="let row">
                    <div class="indicador" [style.--indicador-cor]="getCorOrigem(row.origem)"
                        [matTooltip]="row.origem" [attr.aria-label]="row.origem">
                        {{getSiglaOrigem(row.origem)}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="situacao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Situação</th>
                <td mat-cell *matCellDef="let row">
                    <span class="status-badge" [ngClass]="getSituacaoClass(row.situacao)">
                        {{getSituacaoLabel(row.situacao)}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
                <td mat-cell *matCellDef="let row" class="text-center">
                    <button mat-icon-button [matMenuTriggerFor]="menuAcoes" (click)="$event.stopPropagation()">
                        <mat-icon class="material-symbols-outlined">more_horiz</mat-icon>
                    </button>
                    <mat-menu #menuAcoes="matMenu">
                        @if (isOrigemDocumento(row)) {
                        <span class="ext-menu-item-tooltip" [matTooltip]="tooltipOrigemDocumento(row)">
                            <button mat-menu-item disabled>
                                <mat-icon class="material-symbols-outlined">edit</mat-icon>
                                <span>Editar</span>
                            </button>
                        </span>
                        } @else if (row.situacao !== 'conciliado' && row.isTransferencia) {
                        <button mat-menu-item [routerLink]="['/financas/lancamentos/editar', row.id]">
                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                            <span>Editar</span>
                        </button>
                        } @else if (row.situacao !== 'conciliado') {
                        <button mat-menu-item [routerLink]="['/financas/lancamentos/editar', row.id]">
                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                            <span>Editar</span>
                        </button>
                        } @else {
                        <button mat-menu-item disabled>
                            <mat-icon class="material-symbols-outlined">block</mat-icon>
                            <span>Conciliado não pode ser editado</span>
                        </button>
                        }
                        <button mat-menu-item (click)="abrirModalTags(row)">
                            <mat-icon class="material-symbols-outlined">label</mat-icon>
                            <span>Tags</span>
                        </button>
                        <button mat-menu-item (click)="imprimirRecibos(row)">
                            <mat-icon class="material-symbols-outlined">receipt</mat-icon>
                            <span>Imprimir recibo</span>
                        </button>
                        <span class="ext-menu-item-tooltip" [matTooltip]="tooltipOrigemDocumento(row)" [matTooltipDisabled]="!isOrigemDocumento(row)">
                            <button mat-menu-item (click)="excluirLancamento(row)" [disabled]="isOrigemDocumento(row)">
                                <span class="material-symbols-outlined">delete</span>
                                <span>Excluir</span>
                            </button>
                        </span>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="_colunasVisiveis; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: _colunasVisiveis;" (click)="selection.toggle(row)">
            </tr>
        </table>

        <div class="mobile-view">
            @for (lancamento of _dataSource.data; track lancamento.id) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(lancamento)"
                (click)="selection.toggle(lancamento)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(lancamento) : null"
                            [checked]="selection.isSelected(lancamento)">
                        </mat-checkbox>
                        <div class="d-flex flex-column">
                            <span class="text-bold" [matTooltip]="lancamento.historico">{{lancamento.historico |
                                truncate:50}}</span>
                            <small>{{lancamento.data | date:'dd/MM/yyyy'}}</small>
                        </div>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                        <span
                            [ngClass]="{'valor-entrada': lancamento.tipo === 'entrada', 'valor-saida': lancamento.tipo === 'saida'}">
                            {{formatarValor(lancamento.valor, lancamento.idNaturezaMovimentacao)}}
                        </span>
                        <button mat-icon-button [matMenuTriggerFor]="menuMobile" (click)="$event.stopPropagation()">
                            <span class="material-symbols-outlined">more_horiz</span>
                        </button>
                        <mat-menu #menuMobile="matMenu">
                            @if (isOrigemDocumento(lancamento)) {
                            <span class="ext-menu-item-tooltip" [matTooltip]="tooltipOrigemDocumento(lancamento)">
                                <button mat-menu-item disabled>Editar</button>
                            </span>
                            } @else if (lancamento.situacao !== 'conciliado' && lancamento.isTransferencia) {
                            <button mat-menu-item
                                [routerLink]="['/financas/lancamentos/editar', lancamento.id]">Editar</button>
                            } @else if (lancamento.situacao !== 'conciliado') {
                            <button mat-menu-item
                                [routerLink]="['/financas/lancamentos/editar', lancamento.id]">Editar</button>
                            } @else {
                            <button mat-menu-item disabled>Conciliado não pode ser editado</button>
                            }
                            <button mat-menu-item (click)="abrirModalTags(lancamento)">Tags</button>
                            <button mat-menu-item (click)="imprimirRecibos(lancamento)">Imprimir recibo</button>
                            <span class="ext-menu-item-tooltip" [matTooltip]="tooltipOrigemDocumento(lancamento)" [matTooltipDisabled]="!isOrigemDocumento(lancamento)">
                                <button mat-menu-item (click)="excluirLancamento(lancamento)" [disabled]="isOrigemDocumento(lancamento)">Excluir</button>
                            </span>
                        </mat-menu>
                    </div>
                </div>
                <div class="card-body-mobile">
                    <div class="card-row-mobile">
                        <span class="text-secondary">Categoria</span>
                        <span>{{lancamento.categoria || '-'}}</span>
                    </div>
                    <div class="card-row-mobile">
                        <span class="text-secondary">Situação</span>
                        <span class="status-badge" [ngClass]="getSituacaoClass(lancamento.situacao)">
                            {{getSituacaoLabel(lancamento.situacao)}}
                        </span>
                    </div>
                    <div class="card-row-mobile">
                        <span class="text-secondary">Origem</span>
                        <div class="d-flex align-items-center gap-1">
                            <div class="indicador indicador-sm"
                                [style.--indicador-cor]="getCorOrigem(lancamento.origem)"
                                [attr.aria-label]="lancamento.origem">
                                {{getSiglaOrigem(lancamento.origem)}}
                            </div>
                            <span>{{lancamento.origem}}</span>
                        </div>
                    </div>
                    <div class="card-row-mobile">
                        <span class="text-secondary">Tags</span>
                        <div class="tags-container">
                            @for (m of lancamento.tags; track m.id) {
                            <app-ui-tag [text]="m.descricao" [bgColor]="m.cor"></app-ui-tag>
                            }
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center mt-4 mb-5" style="padding-bottom: 60px;">
            <button mat-button class="btn-ver-mais" [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading) {
                <mat-spinner [diameter]="20"></mat-spinner>
                } @else {
                <span class="material-symbols-outlined">expand_more</span>
                Ver Mais
                }
            </button>
        </div>
        } @else if (_isLoading && _dataSource.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
        <app-empty-list [title]="'Nenhum lançamento encontrado'"
            [subTitle]="'Tente alterar os filtros de busca ou crie um novo lançamento.'">
        </app-empty-list>
        }
    </div>
</div>

<div class="footer-totals">
    <div class="footer-totals-inner">
        <div class="footer-totals-item footer-totals-item--total">
            <span class="footer-totals-label">Saldo inicial</span>
            @if (_ocultarValores) {
            <span class="footer-totals-value">••••</span>
            } @else {
            <span class="footer-totals-value">{{_saldoInicial | abnt:'preco':2}}</span>
            }
        </div>
        <div class="footer-totals-item footer-totals-item--entrada">
            <span class="footer-totals-label">Entradas</span>
            @if (_ocultarValores) {
            <span class="footer-totals-value">••••</span>
            } @else {
            <span class="footer-totals-value">+ {{_totalEntradas | abnt:'preco':2}}</span>
            }
        </div>
        <div class="footer-totals-item footer-totals-item--saida">
            <span class="footer-totals-label">Saídas</span>
            @if (_ocultarValores) {
            <span class="footer-totals-value">••••</span>
            } @else {
            <span class="footer-totals-value">- {{_totalSaidas | abnt:'preco':2}}</span>
            }
        </div>
        <div class="footer-totals-item footer-totals-item--info">
            <span class="footer-totals-label">Saldo final</span>
            @if (_ocultarValores) {
            <span class="footer-totals-value">••••</span>
            } @else {
            <span class="footer-totals-value">{{_saldoFinal | abnt:'preco':2}}</span>
            }
        </div>
        <div class="footer-totals-count">
            <mat-icon class="material-symbols-outlined">description</mat-icon>
            <span>{{_totalRegistros}} Lançamentos</span>
        </div>
        <button mat-icon-button (click)="toggleOcultarValores()" matTooltip="Ocultar/Exibir valores"
            class="icon-mat-symbols-btn">
            <mat-icon class="material-symbols-outlined">
                {{ _ocultarValores ? 'visibility_off' : 'visibility'}}
            </mat-icon>
        </button>
    </div>
</div>
<div class="footer-totals-height-fake"></div>

<!-- Mobile FAB -->
<button type="button" class="btn-footer-totals-mobile" (click)="toggleGavetaMobile()" aria-label="Abrir resumo financeiro">
    <span class="material-symbols-outlined">analytics</span>
</button>

<!-- Mobile Drawer Backdrop -->
@if (isMobileDrawerOpen) {
<div class="footer-totals-mobile-sheet-backdrop" (click)="fecharGavetaMobile()"></div>
}

<!-- Mobile Drawer -->
<div class="footer-totals-mobile-sheet" [class.open]="isMobileDrawerOpen">
    <div class="footer-totals-mobile-sheet__header modal-header">
        <div class="modal-header-icon">
            <mat-icon class="material-symbols-outlined">analytics</mat-icon>
        </div>
        <div class="modal-header-titles">
            <h3 class="modal-title">Resumo Financeiro</h3>
        </div>
        <div class="modal-header-close-btn-container">
            <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" (click)="fecharGavetaMobile()" aria-label="Fechar resumo financeiro">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
        </div>
    </div>
    <div class="footer-totals-mobile-sheet__content">
        <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--total">
            <span class="footer-totals-mobile-sheet__label">SALDO INICIAL</span>
            <span class="footer-totals-mobile-sheet__value">{{ _ocultarValores ? '••••' : (_saldoInicial | abnt:'preco':2) }}</span>
        </div>
        <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--entrada">
            <span class="footer-totals-mobile-sheet__label">ENTRADAS</span>
            <span class="footer-totals-mobile-sheet__value">{{ _ocultarValores ? '••••' : ('+ ' + (_totalEntradas |
                abnt:'preco':2)) }}</span>
        </div>
        <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--saida">
            <span class="footer-totals-mobile-sheet__label">SAÍDAS</span>
            <span class="footer-totals-mobile-sheet__value">{{ _ocultarValores ? '••••' : ('- ' + (_totalSaidas |
                abnt:'preco':2)) }}</span>
        </div>
        <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--info footer-totals-mobile-sheet__item--full">
            <span class="footer-totals-mobile-sheet__label">SALDO FINAL</span>
            <span class="footer-totals-mobile-sheet__value footer-totals-mobile-sheet__total footer-totals-mobile-sheet__total--large">{{ _ocultarValores ? '••••' : (_saldoFinal |
                abnt:'preco':2) }}</span>
        </div>
    </div>
    <div class="footer-totals-mobile-sheet__footer">
        <span class="footer-totals-count">
            <mat-icon class="material-symbols-outlined">description</mat-icon>
            {{ _totalRegistros }} Lançamentos
        </span>
        <button mat-icon-button type="button" class="icon-mat-symbols-btn" (click)="toggleOcultarValores()"
            [matTooltip]="_ocultarValores ? 'Exibir valores' : 'Ocultar valores'"
            [attr.aria-label]="_ocultarValores ? 'Exibir valores' : 'Ocultar valores'">
            <mat-icon class="material-symbols-outlined">{{ _ocultarValores ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
    </div>
</div>
